// default value when numberOfTheaters is not define on widget settings
// eslint-disable-next-line
export const THEATERS_COUNT = 5;
